(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', 'emotion', './VerticalNavItem', './VerticalNavSection', './VerticalNavDivider'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('emotion'), require('./VerticalNavItem'), require('./VerticalNavSection'), require('./VerticalNavDivider'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.react, global.emotion, global.VerticalNavItem, global.VerticalNavSection, global.VerticalNavDivider);
    global.index = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _react, _emotion, _VerticalNavItem, _VerticalNavSection, _VerticalNavDivider) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var React = _interopRequireWildcard(_react);

  var _VerticalNavItem2 = _interopRequireDefault(_VerticalNavItem);

  var _VerticalNavSection2 = _interopRequireDefault(_VerticalNavSection);

  var _VerticalNavDivider2 = _interopRequireDefault(_VerticalNavDivider);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    overflow-x: hidden;\n    overflow-y: auto;\n  '], ['\n    overflow-x: hidden;\n    overflow-y: auto;\n  ']);

  var VerticalNav = function VerticalNav(_ref) {
    var children = _ref.children,
        className = _ref.className,
        label = _ref.label;
    return React.createElement(
      'nav',
      { 'aria-label': label, className: (0, _emotion.cx)(classNames.nav, className) },
      children
    );
  };

  VerticalNav.defaultProps = { className: '' };

  VerticalNav.Section = _VerticalNavSection2.default;
  VerticalNav.Item = _VerticalNavItem2.default;
  VerticalNav.Divider = _VerticalNavDivider2.default;

  var classNames = {
    nav: (0, _emotion.css)(_templateObject)
  };

  exports.default = VerticalNav;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/VerticalNav/index.js
// module id = 2031
// module chunks = 1